export default "__VITE_ASSET__rIjw5zSI__"